module.exports = __webpack_public_path__ + "static/media/banner_1_phone.cb76861f.PNG";